export { default } from './articleItemHorizontal';
